<template>
  <v-footer app class="pa-3"  :fixed="!isMobile" :absolute="isMobile" inset color="#e8e8e8">
    <v-spacer></v-spacer>
    <div>{{ app_name }} Powered By 
    <a :href="'//' + company_website" target="_blank" class="text--white" style="text-decoration:none;">
      {{ company_name }}
    </a>
     </div>
  </v-footer>
</template>
<script>
  import global from '@/components/rbconstants';
  export default {
    data: () => ({
      app_name : global.app_name,
      company_website : global.company_website,
      company_name : global.company_name,
      app_version : global.app_version,
      isMobile: false,
    }),
    watch : {
      isMobile : function() {
          
      }  
    },
    beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 600
    }
  }
  }
</script>

